import styled from 'styled-components';

// iPad cards show a label above every value and wrap the columns into rows.
// The first row holds the 56 px avatar, so with centred cells the "Name"
// label rode 16 px above "Email"/"Phone". Wrapping the (top-aligned) card in
// this gives the row's two other values the avatar's height: every label on
// one line, every value on the avatar's centre line.
// A plain styled.div on purpose: styled(ListCard) at module scope ran before
// the components barrel finished loading and blanked the app (cabac709).
export const TabletAlign = styled.div`
  [data-testid='list-card-content'] > div:nth-child(2) > div:last-child,
  [data-testid='list-card-content'] > div:nth-child(3) > div:last-child {
    padding: 16px 0;
  }
`;
